export default __webpack_public_path__ + "static/tuutau-661d34804919c5bc97084d49d17f6ae1.jpg";